module.exports = __webpack_public_path__ + "img/manage_sub.50352c31.svg";